// src/app/sso/sso-pkce.util.ts
export class SsoPkceUtil {
  private static encoder = new TextEncoder();

  static randomString(length = 64): string {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    const random = new Uint8Array(length);
    crypto.getRandomValues(random);
    return Array.from(random, x => charset[x % charset.length]).join('');
  }

  static async sha256(plain: string): Promise<ArrayBuffer> {
    return crypto.subtle.digest('SHA-256', this.encoder.encode(plain));
  }

  static base64UrlEncode(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    bytes.forEach(b => binary += String.fromCharCode(b));
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  static async generatePkcePair(): Promise<{ verifier: string; challenge: string }> {
    const verifier = this.randomString(64);
    const digest = await this.sha256(verifier);
    const challenge = this.base64UrlEncode(digest);
    return { verifier, challenge };
  }
}